import type { TooltipProps as AriaTooltipProps } from "react-aria-components";

import type { ReactNode } from "react";

import clsx from "clsx";
import { Tooltip as AriaTooltip, Button, TooltipTrigger } from "react-aria-components";

import styles from "./tooltip.module.css";

const DEFAULT_OPEN_DELAY_MS = 300;
const DEFAULT_CLOSE_DELAY_MS = 500;

type TooltipButtonProps = {
	ariaLabel: string;
	className?: string;
};

type TooltipProps = AriaTooltipProps & {
	buttonProps?: TooltipButtonProps;
	children: ReactNode;
	delayMs?: number;
	isDisabled?: boolean;
	needsButton?: boolean;
	text: string;
};

export function Tooltip({
	buttonProps,
	children,
	delayMs,
	isDisabled = false,
	needsButton,
	text,
	...props
}: TooltipProps): ReactNode {
	return (
		<TooltipTrigger
			closeDelay={delayMs || DEFAULT_CLOSE_DELAY_MS}
			delay={delayMs || DEFAULT_OPEN_DELAY_MS}
			isDisabled={isDisabled}
		>
			{needsButton ? (
				<Button
					aria-label={buttonProps?.ariaLabel}
					className={clsx(styles.buttonReset, buttonProps?.className)}
				>
					{children}
				</Button>
			) : (
				children
			)}
			<AriaTooltip {...props} className={clsx(props.className, styles.tooltip)}>
				{text}
			</AriaTooltip>
		</TooltipTrigger>
	);
}
